import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

interface Stage {
  icon: string;
  title: string;
  desc: string;
}

@Component({
  selector: 'app-crm-pipeline',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './crm-pipeline.html',
  styleUrls: ['./crm-pipeline.css'],
})
export class CrmPipelineComponent {
  readonly stages: Stage[] = [
    {
      icon: '🎯',
      title: 'Leads',
      desc: 'Every inquiry lands in one queue — from your website, walk-ins, or referrals — so no one follows up late or misses a name.',
    },
    {
      icon: '👤',
      title: 'Contacts',
      desc: 'One profile per person: their details, every call and message, and what they last asked for, always up to date.',
    },
    {
      icon: '🏢',
      title: 'Accounts',
      desc: 'Contacts are grouped under the business they belong to, so your team sees the whole relationship, not just one person.',
    },
    {
      icon: '📈',
      title: 'Deals',
      desc: 'Every opportunity moves through clear stages, from first quote to signed contract, so nothing stalls without you knowing.',
    },
  ];
}
